import { Container } from 'react-bootstrap';
import AdminNav from './adminNav';
import AuthenticationLayout, { ROLE } from './authLayout';

type AdminLayoutProps = {
  children: React.ReactNode;
  isNavbarHidden?: boolean;
};

export default function AdminLayout({
  children,
  isNavbarHidden = false,
}: AdminLayoutProps) {
  return (
    <AuthenticationLayout RequiredRole={ROLE.ADMIN} isSignInRequired>
      <Container fluid className="mt-3">
        <h1>Admin</h1>
        {!isNavbarHidden && <AdminNav />}
        {children}
      </Container>
    </AuthenticationLayout>
  );
}
